module.exports = __webpack_public_path__ + "img/Menu.a07d3c07.png";